import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import styles from "./index.module.scss";
import { motion } from "framer-motion";
import {useAnimationConfig} from "../../hooks/useAnimationConfig";
import ToolsIcon from '../../components/shared/icons/ToolsIcon';
import SupportModal from '../../components/shared/SupportModal';

const PageInDevelopPage = () => {
  const { t } = useTranslation();
  const { routeVariants} = useAnimationConfig()
  const [supportModal, setSupportModal] = useState(false)
    return (
        <motion.div
          variants={routeVariants}
          initial="initial"
          animate="final"
          className={styles.develop}
        >
           <ToolsIcon />
           <span
            className={styles.text}
           >
             {t('pageInDevelop.message')}
           </span>
           <button
             type={"button"}
             className={styles.button}
             onClick={() => setSupportModal(true)}
           >
              {t('pageInDevelop.feedbackButton')}
           </button>

           {supportModal && <SupportModal
              display={supportModal}
              onClose={() => {setSupportModal(false)}}
              displayHeader={false}
           />}
        </motion.div>
    );
};

export default PageInDevelopPage;
